import React from 'react'
import Tools from "../../../components/Tools/Tools"
import AddDepartmentForm from '../../../components/Multi/Multi-Department/AddDepartment'

const AddDepartment = () => {
  return (
    <div>
      <AddDepartmentForm></AddDepartmentForm>
    </div>
  )
}

export default AddDepartment